const DEFAULT_POLL_INTERNAL = 5000;

export interface TaskPollerProps {
  task: () => Promise<{ isFinished: boolean }>,
  interval?: number,
}

export interface ITaskPoller {
  start: () => Promise<number>,
  stop: () => Promise<number>,
}

export const TaskPoller = (props: TaskPollerProps): ITaskPoller => {
  let timerId: NodeJS.Timer | undefined;
  let stopRunning = false;
  let counter = 0;
  let taskPromise: Promise<number>;
  const interval = props.interval || DEFAULT_POLL_INTERNAL;

  const start = () => {
    if (taskPromise) {
      return taskPromise;
    }

    taskPromise = new Promise((resolve, reject) => {
      // run task immediately once
      counter = 1;
      props.task().then((result) => {
        const { isFinished } = result;
        if (!isFinished && !stopRunning) {
          timerId = setInterval(() => {
            if (!stopRunning) {
              counter += 1;
              props.task().then(({ isFinished: isDone }) => {
                if (isDone) {
                  clearInterval(timerId);
                  timerId = undefined;
                  resolve(counter);
                }
              }).catch((err) => {
                clearInterval(timerId);
                timerId = undefined;
                reject(err);
              });
            } else {
              if (timerId) {
                clearInterval(timerId);
                timerId = undefined;
              }
              resolve(counter);
            }
          }, interval);
        } else {
          resolve(counter);
        }
      }).catch((err) => {
        reject(err);
      });
    });

    return taskPromise;
  };

  const stop = () => {
    stopRunning = true;
    return taskPromise;
  };

  return { start, stop };
};
